import Tab, { type TabProps } from '@mui/material/Tab';
import { Link } from '@tyro/router/components';

export interface LinkTabProps {
  label: string;
  to: string;
  value: TabProps['value'];
  icon?: TabProps['icon'];
}

export function LinkTab(props: LinkTabProps) {
  return <Tab component={Link} {...props} />;
}
